export default "__VITE_ASSET__Dy714lA3__"